import React, { useRef } from 'react';
import SteppedModal from 'components/SteppedModal';
import SocialShareModalContents from './SocialShareModalContents';
import { SocialShareModalProvider } from './SocialShareModalContext';
import { SocialSharePlatforms } from './SocialSharePlatforms';
import useSocialShareConnectedModal from './useSocialShareConnectedModal';

export type SocialShareModalProps = {};

const SocialShareModal: React.FC<SocialShareModalProps> = () => {
  const modalRef = useRef<SteppedModal>(null);

  const { params } = useSocialShareConnectedModal();

  if (!params?.platform) {
    return null;
  }

  return (
    <SocialShareModalProvider modalRef={modalRef}>
      <SocialSharePlatforms>
        <SocialShareModalContents />
      </SocialSharePlatforms>
    </SocialShareModalProvider>
  );
};

export default SocialShareModal;
